<template>
  <div class="section-main__warp">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange">
      <template slot="search_appointmentPark">
        <!-- <div>
          <el-cascader clearable v-model="parkId" :show-all-levels="false" :options="parkType" placeholder="请选择所属园区"
            :props="{
              expandTrigger: 'hover', checkStrictly: true,
              emitPath: false, label: 'parkName', value: 'parkId', children: 'childrens'
            }" />
        </div> -->
        <div>
          <el-select v-model="parkId" placeholder="请选择园区">
            <el-option v-for="item in parkIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-download"
          @click="batchImages">
          导出作业图片
        </el-button>
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-download" @click="batchLists">
          导出作业记录
        </el-button>
      </template>
      <template slot="startWorkTime" slot-scope="scope">
        <span>{{ getTimeStr(scope.row.startWorkTime) }}</span>
      </template>
      <template slot="finishWorkTime" slot-scope="scope">
        <span>{{ getTimeStr(scope.row.finishWorkTime) }}</span>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-tickets" @click="handleView(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 2px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="下载" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-download" @click="handleListDownload(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog title="作业详情" :visible.sync="detailVisible" append-to-body :close-on-click-modal="modalClose" width="46%">
      <div style="height: 600px; overflow-y: auto;">
        <el-descriptions border>
          <el-descriptions-item label="司机姓名">{{ detailForm.driverName }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ detailForm.phone }}</el-descriptions-item>
          <el-descriptions-item label="车辆类型">{{ detailForm.vehicleTypeName }}</el-descriptions-item>
          <el-descriptions-item label="前车车牌">{{ detailForm.frontVehicleNumber }}</el-descriptions-item>
          <el-descriptions-item label="挂车车牌">{{ detailForm.trailerVehicleNumber }}</el-descriptions-item>
          <el-descriptions-item label="车长">{{ detailForm.vehicleLong }}</el-descriptions-item>
          <el-descriptions-item label="园区">{{ detailForm.appointmentParkName }}</el-descriptions-item>
          <el-descriptions-item label="装/卸货">{{ operateTypeRender(detailForm.operateType) }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ workStatusRender(detailForm.workStatus) }}</el-descriptions-item>
        </el-descriptions>
        <div style="font-size: 15px; font-weight: 600; margin: 20px 0 10px 0;">车辆入园信息：</div>
        <el-card>
          <el-form :inline="true" :model="vehicleAppointmentIn" label-width="110px" label-position="right"
            label-suffix=" :">
            <el-row>
              <el-col :span="12">
                <el-form-item label="预约时间">{{ vehicleAppointmentIn && vehicleAppointmentIn.createTime }}</el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="预计到达时间">{{ vehicleAppointmentIn && vehicleAppointmentIn.estimatedArrivalTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户">{{ platformWorkInfo.custom }}</el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="柜号">{{ platformWorkInfo.cabinetNumber }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="入园审批时间">{{ vehicleAppointmentIn && vehicleAppointmentIn.approveTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="驾驶证">
                  <div>
                    <img style="width: 150px;height: 150px;cursor: pointer;position: absolute;"
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(vehicleAppointmentIn && vehicleAppointmentIn.driverLicense)"
                      @click="showViewer(vehicleAppointmentIn && vehicleAppointmentIn.driverLicense)" />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="行驶证">
                  <div>
                    <img style="width: 150px;height: 150px;cursor: pointer;position: absolute;"
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(vehicleAppointmentIn && vehicleAppointmentIn.travelLicense)"
                      @click="showViewer(vehicleAppointmentIn && vehicleAppointmentIn.travelLicense)" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="前车车牌照片">
                  <div>
                    <img style="width: 150px;height: 150px;cursor: pointer;position: absolute;"
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(vehicleAppointmentIn && vehicleAppointmentIn.licensePlatePicture)"
                      @click="showViewer(vehicleAppointmentIn && vehicleAppointmentIn.licensePlatePicture)" />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="柜号照片">
                  <div>
                    <img style="width: 150px;height: 150px;cursor: pointer;position: absolute;"
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(vehicleAppointmentIn && vehicleAppointmentIn.cabinetNumberPicture)"
                      @click="showViewer(vehicleAppointmentIn && vehicleAppointmentIn.cabinetNumberPicture)" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <div v-if="Number(detailForm.workStatus) >= 1"
          style="font-size: 15px; font-weight: 600; margin: 20px 0 10px 0;">
          车辆作业信息：</div>
        <el-card v-if="Number(detailForm.workStatus) >= 1">
          <el-form :inline="true" :model="platformWorkInfo" label-width="110px" label-position="right"
            label-suffix=" :">
            <el-row>
              <el-col :span="12">
                <el-form-item label="库管">{{ platformWorkInfo.storekeeperName }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="作业月台">{{ platformWorkInfo.platformName }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="调度">{{ platformWorkInfo.dispatcherName }}</el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="调度时间">{{ platformWorkInfo.dispatchTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="开始作业时间">{{ platformWorkInfo.startWorkTime }}</el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="结束作业时间">{{ platformWorkInfo.finishWorkTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="开始作业图片">
                  <div>
                    <img style="width: 150px;height: 150px;cursor: pointer;position: absolute;"
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(platformWorkInfo.startWorkImg)"
                      @click="showViewer(platformWorkInfo.startWorkImg)" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <div v-if="Number(detailForm.workStatus) >= 4"
          style="font-size: 15px; font-weight: 600; margin: 20px 0 10px 0;">
          车辆出园信息：</div>
        <el-card v-if="Number(detailForm.workStatus) >= 4">
          <el-form :inline="true" :model="vehicleAppointmentOut" label-width="110px" label-position="right"
            label-suffix=" :">
            <el-row>
              <el-col :span="12">
                <el-form-item label="出园申请时间">{{ vehicleAppointmentOut && vehicleAppointmentOut.createTime }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出园审批时间">{{ vehicleAppointmentOut && vehicleAppointmentOut.approveTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="门卫">{{ platformWorkInfo.doorkeeperName }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门卫拍照时间">{{ vehicleAppointmentOut && getTimeStr(vehicleAppointmentOut.checkInTime) }}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="门卫拍照">
                  <div>
                    <img style="width: 150px;height: 150px;cursor: pointer;position: absolute;"
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(vehicleAppointmentOut && vehicleAppointmentOut.picture)"
                      @click="showViewer(vehicleAppointmentOut && vehicleAppointmentOut.picture)" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleImageDownload(detailForm.id)">作业图片下载</el-button>
        <el-button @click="detailCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import tableOption from "../config/homeworkTable";
import { formatTimeToStr } from "../filter/dateUtils";
import utils from "@src/common/utils";
import { Bus } from "$utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      parkId: '',
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      detailVisible: false,
      modalClose: false,
      detailForm: {},
      checkedIds: [],
      parkType: [],
      parkIdOptions: [],
      workStatusArr: [{ 'label': '待签到', 'value': '-1' }, { 'label': '已签到', 'value': '0' }, { 'label': '未开始', 'value': '1' },
      { 'label': '作业中', 'value': '2' }, { 'label': '完成作业', 'value': '3' }, { 'label': '待审批', 'value': '4' },
      { 'label': '待出园', 'value': '5' }, { 'label': '己出园', 'value': '6' }, { 'label': '作废', 'value': '9' }],
      vehicleAppointmentIn: {},
      platformWorkInfo: {},
      vehicleAppointmentOut: {}
    };
  },
  created() {
    this.getPark()
    this.getList()
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item.split(',')[0]) : "";
    },
    showViewer(item) {
      if (!item) return;
      this.$app.AppInstance.handleShowViewer(
        item.split(',').map(o => this.getImgPath(o))
      );
    },
    getPark() {
      let params = {};
      this.$fetch(api.queryAreaTree, params).then((response) => {
        if (response.success) {
          this.parkIdOptions = [{
            label: response.returnObj[0].areaDevGroupName,
            value: response.returnObj[0].areaDevGroupCode
          }]
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    getTimeStr(time) {
      if (time) {
        const nowTime = new Date(time)
        const y = nowTime.getFullYear()
        let M = nowTime.getMonth() + 1
        M = M < 10 ? '0' + M : M
        let d = nowTime.getDate()
        d = d < 10 ? '0' + d : d
        let h = nowTime.getHours()
        h = h < 10 ? '0' + h : h
        let m = nowTime.getMinutes()
        m = m < 10 ? '0' + m : m
        let s = nowTime.getSeconds()
        s = s < 10 ? '0' + s : s
        const currentDate = y + '/' + M + '/' + d
        const currentTime = h + ':' + m + ':' + s
        return currentDate + ' ' + currentTime
      }
    },
    operateTypeRender(value) {
      if (Number(value) === 1) {
        return "装货";
      } else if (Number(value) === 2) {
        return "卸货";
      }
      return "";
    },
    handleUpdate() {
      this.getList();
    },
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.parkId = '';
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSelectionChange(items) {
      this.checkedIds = items.map((item) => {
        return item.id;
      });
    },
    getList() {
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        appointmentPark: this.parkId == '' ? null : this.parkId,
        custom: this.searchForm.custom,
        operateType: this.searchForm.operateType,
        cabinetNumber: this.searchForm.cabinetNumber,
        driverName: this.searchForm.driverName,
        workStatus: this.searchForm.workStatus
      };
      if (this.searchForm.workTime && this.searchForm.workTime.length > 0) {
        params.startWorkTime = formatTimeToStr(this.searchForm.workTime[0]);
        params.finishWorkTime = formatTimeToStr(this.searchForm.workTime[1]);
      }
      this.$fetch(api.work.queryhomeworkPic, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleView(row) {
      this.queryWorkDetail(row.serialNumber)
      this.detailForm.id = row.id
      this.detailForm.driverName = row.driverName
      this.detailForm.phone = row.phone
      this.detailForm.frontVehicleNumber = row.frontVehicleNumber
      this.detailForm.trailerVehicleNumber = row.trailerVehicleNumber
      this.detailForm.vehicleTypeName = row.vehicleTypeName
      this.detailForm.vehicleLong = row.vehicleLong
      this.detailForm.appointmentParkName = row.appointmentParkName
      this.detailForm.operateType = row.operateType
      this.detailForm.platformName = row.platformName
      this.detailForm.storekeeperName = row.storekeeperName
      this.detailForm.startWorkTime = row.startWorkTime
      this.detailForm.finishWorkTime = row.finishWorkTime
      this.detailForm.custom = row.custom
      this.detailForm.cabinetNumber = row.cabinetNumber
      this.detailForm.dispatcherName = row.dispatcherName
      this.detailForm.doorkeeperName = row.doorkeeperName
      this.detailForm.workStatus = row.workStatus
      this.detailVisible = true
    },
    queryWorkDetail(val) {
      let params = {
        serialNumber: val
      };
      this.$fetch(api.work.workDetail, params).then((response) => {
        if (response.success) {
          this.vehicleAppointmentIn = response.returnObj.VehicleAppointmentIn
          this.platformWorkInfo = response.returnObj.PlatformWorkInfo
          this.vehicleAppointmentOut = response.returnObj.VehicleAppointmentOut
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    workStatusRender(data) {
      for (let i = 0; i < this.workStatusArr.length; i++) {
        if (this.workStatusArr[i].value == data) {
          return this.workStatusArr[i].label
        }
      }
    },
    detailCancel() {
      this.detailForm = {}
      this.detailVisible = false
    },
    batchImages() {
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        appointmentPark: this.parkId == '' ? null : this.parkId,
        custom: this.searchForm.custom,
        operateType: this.searchForm.operateType,
        cabinetNumber: this.searchForm.cabinetNumber,
        driverName: this.searchForm.driverName,
        workStatus: this.searchForm.workStatus,
      };
      if (this.searchForm.workTime && this.searchForm.workTime.length > 0) {
        params.startWorkTime = formatTimeToStr(this.searchForm.workTime[0]);
        params.finishWorkTime = formatTimeToStr(this.searchForm.workTime[1]);
      }
      this.$fetchDownLoad(api.work.exportHomeworkPic, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName = '作业图片' + ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    batchLists() {
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        appointmentPark: this.parkId == '' ? null : this.parkId,
        custom: this.searchForm.custom,
        operateType: this.searchForm.operateType,
        cabinetNumber: this.searchForm.cabinetNumber,
        driverName: this.searchForm.driverName,
        workStatus: this.searchForm.workStatus,
      };
      if (this.searchForm.workTime && this.searchForm.workTime.length > 0) {
        params.startWorkTime = formatTimeToStr(this.searchForm.workTime[0]);
        params.finishWorkTime = formatTimeToStr(this.searchForm.workTime[1]);
      }
      this.$fetchDownLoad(api.work.exportHomework, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        // const blob = new Blob([content], { type: "application/zip" });
        const blob = new Blob([content]);
        const currentTime = new Date().getTime()
        const fileName = '作业记录' + currentTime + '.xlsx';
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    handleListDownload(row) {
      let params = {
        id: row.id
      }
      this.$fetchDownLoad(api.work.exportHomework, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const currentTime = new Date().getTime()
        const fileName = '作业记录' + currentTime + '.xlsx';
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    handleImageDownload(id) {
      let params = {
        id: id,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        appointmentPark: this.parkId == '' ? null : this.parkId,
        custom: this.searchForm.custom,
        operateType: this.searchForm.operateType,
        cabinetNumber: this.searchForm.cabinetNumber,
        driverName: this.searchForm.driverName,
        workStatus: this.searchForm.workStatus,
      };
      if (this.searchForm.workTime && this.searchForm.workTime.length > 0) {
        params.startWorkTime = formatTimeToStr(this.searchForm.workTime[0]);
        params.finishWorkTime = formatTimeToStr(this.searchForm.workTime[1]);
      }
      this.$fetchDownLoad(api.work.exportHomeworkPic, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName = '作业图片' + ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.img-info-box {
  margin-bottom: 120px;
  position: relative;

  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>